export class PlainDate {
    constructor(year, month, day) {
        this.year = Number(year);
        this.month = Number(month);
        this.day = Number(day);
    }

    getYear() { return this.year; }
    getMonth() { return this.month; }
    getDay() { return this.day; }

    toString() {
        return `${this.year}-${String(this.month).padStart(2, "0")}-${String(this.day).padStart(2, "0")}`;
    }

    nextMonth() {
        let nextYear = this.year;
        let nextMonth = this.month + 1;
        if (nextMonth > 12) {
            nextMonth = 1;
            nextYear += 1;
        }
        return new PlainDate(nextYear, nextMonth, this.day);
    }

    previousMonth() {
        let prevYear = this.year;
        let prevMonth = this.month - 1;
        if (prevMonth < 1) {
            prevMonth = 12;
            prevYear -= 1;
        }
        return new PlainDate(prevYear, prevMonth, this.day);
    }

    static fromString(str) {
        const [y, m, d] = str.split("-").map(Number);
        return new PlainDate(y, m, d);
    }

    toDate() {
        return new Date(this.year, this.month - 1, this.day);
    }
}

function extractParts(str) {
    const [prefix, numStr] = str.split("-");
    return { prefix, num: parseInt(numStr, 10) };
}

export function sortProductInstances(productInstances) {
    return [...productInstances].sort((a, b) => {
        const pa = extractParts(a.name);
        const pb = extractParts(b.name);

        const prefixDiff = pa.prefix.localeCompare(pb.prefix);
        if (prefixDiff !== 0) return prefixDiff;

        return pa.num - pb.num;
    });
}